/**
 * @tencent/image-components 异步加载封装
 */
import type { ImageUploader, ImageOption, Compressor } from '@tencent/image-components';

function useImageComponents() {
    return import('@tencent/image-components');
}

type UploadImageCrossDomainParams = Parameters<typeof ImageUploader.uploadImageCrossDomain>;

export async function uploadImageCrossDomain(...args: UploadImageCrossDomainParams): Promise<void> {
    const { ImageUploader } = await useImageComponents();
    return ImageUploader.uploadImageCrossDomain(...args);
}

type ImageOptionParams = ConstructorParameters<typeof ImageOption>;

export async function createImageOption(...args: ImageOptionParams): Promise<ImageOption> {
    const { ImageOption } = await useImageComponents();
    return new ImageOption(...args);
}


type MaybeShrinkImageParams = Parameters<typeof Compressor.maybeShrinkImage>;

export async function maybeShrinkImage(...args: MaybeShrinkImageParams): Promise<void> {
    const { Compressor } = await useImageComponents();
    return Compressor.maybeShrinkImage(...args);
}

export { ImageUploader, ImageOption, Compressor };
